/** 実際に送る上限内の動画について、URLと素材IDの対応を確認する。 */
export function collectReferenceVideoInputs(
  assets: ReadonlyArray<{ id?: string | null; sourceUrl?: string | null }>,
  maxVideos: number,
) {
  const urls: string[] = [];
  const materialIds: string[] = [];
  let hasMissingMaterialId = false;
  for (const asset of assets) {
    if (urls.length >= maxVideos) break;
    const url = asset.sourceUrl?.trim();
    if (!url) continue;
    urls.push(url);
    const id = asset.id?.trim();
    if (id) materialIds.push(id);
    else hasMissingMaterialId = true;
  }
  return { urls, materialIds, hasMissingMaterialId };
}
